import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './app.config';
import DevExWidget from './components/DevExWidget';
import '../../../css/developerExchange/devExWidget.scss';

function App({ translate, intl }) {
  return (
    <Fragment>
      <DevExWidget translate={translate} intl={intl} />
    </Fragment>
  );
}

App.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    n: PropTypes.func.isRequired,
    d: PropTypes.func.isRequired
  }).isRequired
};

export default withTranslations(App, translationConfig);
